// extracted by mini-css-extract-plugin
module.exports = {"chartPlaceHolder":"Parking_chartPlaceHolder__3KFbS","chartLegend":"Parking_chartLegend__2zqUn"};